import { useRef, useState } from "react";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool/index.js";

import { Input, Text } from "@fragments";

import { InsertPhotoRounded, SettingsRounded } from "@mui/icons-material";

import api from "@helpers/api";

import "./styles.scss";

export default function CreateCommunityModal({ open, onClose, onSuccess }) {
    const [loading, setLoading] = useState(false);

    const REF_data = useRef({
        name: "",
        description: "",
        banner_base64: null,
    });

    const [bannerPreview, setBannerPreview] = useState(null);

    function handleChange(key, value) {
        REF_data.current[key] = value;
    }

    async function handleSubmit() {
        const data = REF_data.current;

        // Validate name
        if (!data.name || data.name.trim().length === 0) {
            window.setSnackbar("O nome da comunidade é obrigatório");
            return;
        }
        const nameLength = data.name.trim().length;
        if (nameLength < 3 || nameLength > 25) {
            window.setSnackbar("O nome da comunidade deve ter entre 3 e 25 caracteres");
            return;
        }

        const payload = {
            name: data.name.trim(),
        };

        if (data.description && data.description.trim().length > 0) {
            payload.description = data.description.trim();
        }

        if (data.banner_base64) {
            payload.banner_base64 = data.banner_base64;
        }

        try {
            setLoading(true);
            const { data: response } = await api.post("/community", payload);

            if (response?.id || response?.slug) {
                window.setSnackbar("Comunidade criada com sucesso! 🎉");

                onSuccess?.(response);
                handleClose();

                if (response?.slug) {
                    window.navigate?.("/" + response.slug);
                    window.location.reload();
                }
            } else {
                window.setSnackbar("Houve um erro ao criar a comunidade, tente novamente");
            }
        } catch (e) {
            console.error(e);
            window.setSnackbar("Houve um erro ao criar a comunidade, tente novamente");
        } finally {
            setLoading(false);
        }
    }

    function handleClose() {
        REF_data.current = { name: "", description: "", banner_base64: null };
        setBannerPreview(null);
        onClose?.();
    }

    const bodyComponent = (
        <div className="create-community-modal-body px-5 pb-3 pt-4">
            <Text.h3
                value="Configurações gerais"
                left={<SettingsRounded />}
                className="mb-2"
            />
            <Input.Text
                variant="dark"
                className="mt-2"
                label="Nome da comunidade"
                size={25}
                placeholder="Ex: Minha Comunidade Fit"
                onInput={(v) => handleChange("name", v)}
            />

            <Input.Text
                variant="dark"
                className="mt-3"
                label="Descrição (opcional)"
                size={250}
                multiline
                emoji
                placeholder="Descreva sua comunidade em poucas palavras…"
                onInput={(v) => handleChange("description", v)}
            />

            <div className="mt-4">
                <Text.h3
                    value="Foto de perfil da comunidade"
                    left={<InsertPhotoRounded />}
                    className="mb-2"
                />
                <Text.h5
                    contrast={5}
                    value="Adicione uma foto de perfil no tamanho 720px por 720px (1:1)"
                />
                <ImageImportTool
                    className="mt-2 banner-upload-creation"
                    variant="dark"
                    src={bannerPreview}
                    size={135}
                    onCrop={(imageBase64) => {
                        handleChange("banner_base64", imageBase64);
                        setBannerPreview(imageBase64);
                    }}
                    title="Redimensionar foto de perfil da comunidade"
                />
            </div>
        </div>
    );

    return (
        <CustomModal
            open={open}
            handleClose={handleClose}
            title="Criar comunidade"
            maxWidth={520}
            loading={loading}
            bodyComponent={bodyComponent}
            bottomButtonSumbitText="Criar comunidade"
            handleSubmit={handleSubmit}
            disabled={loading}
        />
    );
}
